import React from "react"
import Konva from "konva"
import {
    Group,
    Arrow,
    Text,
    Rect,
    Line,
    RegularPolygon,
} from "react-konva"
import {
    colors,
    font,
    phaseWidth,
    inputDocumentsWidth,
    outputDocumentsWidth,
    childMarkerWidth,
} from "./const"


interface ConnectionArrowProps extends Konva.ArrowConfig {
    points: number[]
    pointerAtBeginning: boolean
    active: boolean
    onClick: (e: Konva.KonvaEventObject<MouseEvent>) => void
}
export const ConnectionArrow = ({
    points,
    pointerAtBeginning,
    active,
    onClick,
}: ConnectionArrowProps) => (
    <Arrow
        points={points}
        pointerAtBeginning={pointerAtBeginning}
        pointerLength={10}
        pointerWidth={7}
        fill={active ? colors.arrowSelectedColor : colors.arrowColor}
        stroke={active ? colors.arrowSelectedColor : colors.arrowColor}
        strokeWidth={1}
        hitStrokeWidth={20}
        onClick={onClick}
    />
)


export const PreviewConnectionOptions = (points: number[]) => {
    const options: Konva.ArrowConfig = {
        points,
        pointerLength: 10,
        pointerWidth: 7,
        fill: colors.arrowSelectedColor,
        stroke: colors.arrowSelectedColor,
        strokeWidth: 1,
        hitStrokeWidth: 20,
        listening: false,
    }
    return options
}


interface PhaseRectProps extends Konva.RectConfig {
    height: number
}
export const PhaseRect = ({
    height,
}: PhaseRectProps) => (
    <Rect
        width={phaseWidth}
        height={height}
        fill={colors.phaseBackgroundBase}
        shadowColor={colors.phaseShadowColor}
        shadowBlur={10}
        shadowOffsetX={10}
        shadowOffsetY={10}
        shadowOpacity={0.4}
        strokeWidth={1}
        stroke={colors.phaseBorderColor}
    />
)


interface InOutDocsProps extends Konva.TextConfig {
    childPhases?: boolean
    height: number
    text: string
    visible: boolean
}
const inOutStyleConfig: Konva.TextConfig = {
    fontSize: 12,
    fontFamily: font,
    lineHeight: 1,
    fill: colors.phaseTextColor,
    padding: 5,
    align: "center",
    verticalAlign: "middle",
}
export const InputDocs = ({
    height,
    text,
    visible,
}: InOutDocsProps) => (
    <Text
        x={0}
        y={0}
        width={inputDocumentsWidth}
        height={height}
        text={text}
        visible={visible}
        {...inOutStyleConfig}
    />
)
export const OutputDocs = ({
    childPhases,
    height,
    text,
    visible,
}: InOutDocsProps) => (
    <Text
        x={phaseWidth - outputDocumentsWidth}
        y={0}
        width={childPhases
            ? outputDocumentsWidth + childMarkerWidth
            : outputDocumentsWidth}
        height={height}
        text={text}
        visible={visible}
        {...inOutStyleConfig}
    />
)


interface PhaseTitleProps extends Konva.TextConfig {
    text: string
}
const PhaseTitleOptions = (text: string) => {
    const options: Konva.TextConfig = {
        x: inputDocumentsWidth,
        y: 0,
        width: phaseWidth - inputDocumentsWidth - outputDocumentsWidth,
        text,
        fontSize: 14,
        fontFamily: font,
        lineHeight: 1.5,
        fill: colors.phaseTextColor,
        padding: 10,
        align: "center",
    }
    return options
}
export const PhaseTitle = ({
    text,
}: PhaseTitleProps) => (
    <Text {...PhaseTitleOptions(text)} />
)
export const PhaseTitleHeight = (text: string) => {
    const titleConfig = PhaseTitleOptions(text)
    const title = new Konva.Text(titleConfig)
    const titleHeight = title.height()
    return titleHeight
}


interface ChildMarkerProps {
    visible: boolean
}
export const ChildMarker = ({
    visible,
}: ChildMarkerProps) => (
    <Group
        x={phaseWidth - childMarkerWidth}
        y={0}
        visible={visible}
    >
        <Line
            points={[0, 0, 0, childMarkerWidth, childMarkerWidth, childMarkerWidth]}
            fill={colors.phaseBackgroundTr1}
            closed
        />
        <Line
            points={[0, 0, childMarkerWidth, 0, childMarkerWidth, childMarkerWidth]}
            fill={colors.phaseBackgroundTr2}
            closed
        />
    </Group>
)


interface GuiLineProps extends Konva.LineConfig {
    points: number[]
}
export const GuiLine = ({
    points,
}: GuiLineProps) => (
    <Line
        points={points}
        stroke={colors.guiBorderColor}
        strokeWidth={2}
    />
)


interface GuiPointProps {
    x: number
    y: number
    active: boolean
    visible: boolean
    onClick: (e: Konva.KonvaEventObject<MouseEvent>) => void
    onMouseEnter: (e: Konva.KonvaEventObject<MouseEvent>) => void
    onMouseOut: (e: Konva.KonvaEventObject<MouseEvent>) => void
    onMouseMove: (e: Konva.KonvaEventObject<MouseEvent>) => void
}
export const GuiPoint = ({
    x,
    y,
    active,
    visible,
    onClick,
    onMouseEnter,
    onMouseOut,
    onMouseMove,
}: GuiPointProps) => (
    <RegularPolygon
        x={x}
        y={y}
        sides={4}
        rotation={0}
        radius={active ? 6 : 4}
        hitStrokeWidth={20}
        fill={colors.guiPointColor}
        visible={visible}
        listening={visible}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseOut={onMouseOut}
        onMouseMove={onMouseMove}
    />
)
